export enum FeatureFlag {
  CourseCards = 'course_cards',
}
